var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-company-info-wrapper",
    { attrs: { company: _vm.value, "no-scroll": "" } },
    [
      _c(
        "w-button-bar",
        { attrs: { slot: "actions" }, slot: "actions" },
        [
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.showDossierInfoToolTip,
                  expression: "showDossierInfoToolTip",
                },
              ],
              attrs: { disabled: _vm.allowededToView },
              on: {
                click: function ($event) {
                  return _vm.showDossierInfo()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "eye" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { attrs: { grow: "", shrink: "" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-data-table", {
                staticStyle: { "flex-grow": "1" },
                attrs: {
                  columns: _vm.columns,
                  items: _vm.value.dossiers,
                  "selected-items": _vm.selectedRows,
                },
                on: {
                  "item-clicked": function ($event) {
                    return _vm.showDossierInfo($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }